export const es = {
  'app.loading': 'Cargando…',
  'app.loading_modal': 'Cargando modal…',
  'app.loading_editor': 'Cargando editor…',
  'app.loading_ai_config': 'Cargando configuración de IA…',

  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.create': 'Crear',

  'lang.switcher_label': 'Idioma de la app',
  'lang.es': 'ES',
  'lang.en': 'EN',

  'projects.beta_checking': 'Verificando acceso…',
  'projects.beta_closed': 'Acceso limitado',
  'projects.sign_in': 'Entrar',
  'projects.title': 'Writer\'s Lens',
  'projects.subtitle': 'Tus Proyectos de Escritura',
  'projects.new_project': 'Nuevo Proyecto',
  'projects.import_project': 'Importar Proyecto',
  'projects.install_example': 'Instalar proyecto guía (ES/EN)',
  'projects.install_example_running': 'Instalando guía…',
  'projects.install_example_success': 'Proyectos guía instalados: {created}. Ya existentes: {skipped}.',
  'projects.install_example_already': 'Los proyectos guía ya estaban instalados.',
  'projects.install_example_error': 'No se pudo instalar el proyecto guía.',
  'projects.resume_last_session': 'Última sesión',
  'projects.resume_syncing': 'Buscando tu lugar…',
  'projects.resume_last_used': 'Último uso {time}',
  'projects.resume_last_synced_from_device': 'Última sync desde {device}',
  'projects.resume_device_mobile': 'móvil',
  'projects.resume_device_desktop': 'escritorio',
  'projects.resume_workspace_editor': 'Continuar escribiendo',
  'projects.resume_workspace_global_lens': 'Continuar en Atlas',
  'projects.resume_workspace_idea_lens': 'Continuar en Idea Lens',
  'projects.resume_restore_exact': 'Hemos restaurado tu último punto de trabajo.',
  'projects.resume_restore_approximate': 'Hemos reabierto el lugar correcto, pero el fragmento exacto se ha movido.',
  'projects.resume_restore_incomplete': 'Hemos recuperado el contexto, pero la reentrada exacta no terminó de asentarse.',
  'projects.resume_restore_stale': 'Tu último punto guardado ya no está disponible. Hemos abierto el lugar seguro más cercano.',
  'projects.resume_restore_workspace_global_lens': 'Hemos restaurado tu último contexto de Atlas.',
  'projects.resume_restore_workspace_idea_lens': 'Hemos restaurado tu último contexto de Idea Lens.',
  'projects.footer_privacy': 'Privacidad',
  'projects.footer_terms': 'Términos',
  'projects.footer_security': 'Seguridad',
  'projects.footer_closed_beta': 'Beta pública · Writer\'s Lens',

  'project_card.status.draft': 'Borrador',
  'project_card.status.in_progress': 'En progreso',
  'project_card.status.review': 'Revisión',
  'project_card.status.completed': 'Completado',
  'project_card.by_author': 'por {author}',
  'project_card.progress': 'Progreso',
  'project_card.words_progress': '{progress} / {target} palabras',
  'project_card.completed_pct': '{pct}% completado',

  'header.no_project': 'Sin proyecto',
  'header.app_subtitle': 'Tu asistente de escritura creativa',
  'header.sign_in': 'Entrar',
  'header.beta_closed': 'Acceso limitado',
  'header.protection': 'Protección',
  'header.protection_no_key': 'Sin clave',
  'header.protection_ready': 'Protegido',
  'header.protection_title': 'Estado de protección (clic para gestionar la clave)',
  'header.search_project': 'Buscar en el proyecto',
  'header.open_project_tools': 'Abrir herramientas del proyecto',

  'usermenu.premium_account': 'Cuenta Premium',
  'usermenu.plan_free': 'Plan Free',
  'usermenu.plan_premium': 'Plan Premium',
  'usermenu.debug': 'Debug',
  'usermenu.sync_cloud': 'Sync con la nube',
  'usermenu.sync_diagnostics': 'Diagnóstico sync',
  'usermenu.sync_blocked_beta': 'Acceso progresivo: la sync cloud todavía no está disponible para esta cuenta.',
  'usermenu.sync_blocked_plan': 'Premium: la sync cloud está disponible en el plan Premium según el perfil actual.',
  'usermenu.sync_plan_hint': 'Revisa `profiles.plan` si esta cuenta debería tener Premium.',
  'usermenu.sync_availability': 'Disponibilidad',
  'usermenu.sync_state_active': 'Activa',
  'usermenu.sync_state_inactive': 'Desactivada',
  'usermenu.sync_state_blocked': 'Bloqueada',
  'usermenu.sync_state_review_required': 'Requiere revisión',
  'usermenu.sync_state_remote_recovery': 'Recuperación remota completada',
  'usermenu.sync_state_warnings': 'Sync con advertencias',
  'usermenu.sync_syncing': 'Sincronizando…',
  'usermenu.sync_starting': 'Iniciando…',
  'usermenu.sync_analyzing': 'Analizando…',
  'usermenu.sync_last': 'Última sync: {time}',
  'usermenu.sync_never': 'Nunca sincronizado en esta sesión',
  'usermenu.sync_no_project': 'Abre un proyecto para sincronizar.',
  'usermenu.sync_offline': 'Sin conexión',
  'usermenu.sync_fast_ok': 'Sync completada sin riesgos (no fue necesario abrir Sync segura).',
  'usermenu.sync_warn_metadata_phase': 'Timeout en fases de metadatos (proyectos/versiones); el push de contenidos continuó.',
  'usermenu.sync_warn_assets_pending': 'La imagen no se pudo subir a Supabase; el texto sí se sincronizó.',
  'usermenu.sync_done_with_warnings': 'Sync completada con advertencias.',
  'usermenu.sync_auth_fallback': 'Sesión en modo compatibilidad Safari (fallback local).',
  'usermenu.vault_active': 'Bóveda cifrada activa',
  'usermenu.sync_now_hint': 'Sync now del proyecto activo: intenta una sync rápida y abre Sync segura si detecta riesgos.',
  'usermenu.sync_safe_hint': 'Safe sync del proyecto activo: analiza conflictos y te deja decidir antes de aplicar cambios.',
  'usermenu.sync_now_tooltip': 'Sincronización rápida. Si hay riesgos o backend degradado, abre Sync segura.',
  'usermenu.sync_safe_tooltip': 'Abre el análisis de conflictos para decidir manualmente qué conservar.',
  'usermenu.sync_now': 'Sync ahora',
  'usermenu.sync_safe': 'Sync segura…',
  'usermenu.close_project': 'Cerrar proyecto',
  'usermenu.switch_account_hint': 'Para probar otra cuenta en este navegador, cierra sesión y vuelve a iniciar. Para sesiones simultáneas usa otro perfil o incógnito.',
  'usermenu.sign_out': 'Cerrar sesión',
  'outline.part_badge': 'Part',
  'outline.add_part': 'Añadir parte',

  'login.title_signup': 'Crear Cuenta',
  'login.title_signin': 'Iniciar Sesión',
  'login.email': 'Email',
  'login.password': 'Contraseña',
  'login.submit_signup': 'Crear Cuenta',
  'login.submit_signin': 'Iniciar Sesión',
  'login.loading': 'Cargando...',
  'login.close': 'Cerrar',
  'login.unexpected_error': 'Error inesperado. Por favor intenta de nuevo.',
  'login.github_error': 'Error con GitHub: {message}',
  'login.github_unexpected': 'Error inesperado al conectar con GitHub.',
  'login.or': 'O',
  'login.github_continue': 'Continuar con GitHub',
  'login.github_connecting': 'Conectando...',
  'login.toggle_to_signin': '¿Ya tienes cuenta? Inicia sesión',
  'login.toggle_to_signup': '¿No tienes cuenta? Regístrate',
  'login.msg_invalid_credentials': 'Email o contraseña incorrectos',
  'login.msg_confirm_email': 'Por favor confirma tu email antes de iniciar sesión',
  'login.msg_email_registered': 'Este email ya está registrado. Prueba a iniciar sesión.',
  'login.msg_redirect': 'Revisa Redirect URLs en Supabase Auth (incluye tu dominio de Netlify y localhost).',
  'login.msg_password_short': 'La contraseña debe tener al menos 6 caracteres',
  'login.msg_signup_success': 'Registro exitoso. Revisa tu email y usa el enlace de confirmación. Luego vuelve e inicia sesión.',

  'import.title': 'Importar Proyecto',
  'import.select_file': 'Selecciona un archivo exportado (.txt, .md o .json).',
  'import.file': 'Archivo',
  'import.detected_title': 'Título detectado',
  'import.author': 'Autor',
  'import.author_default': 'Autor',
  'import.language': 'Idioma',
  'import.sections_detected': 'Secciones detectadas',
  'import.sync_blocked_notice': 'Este proyecto se importará con sync remoto bloqueado hasta que definas una clave local en Gray Matter Zone.',
  'import.cancel': 'Cancelar',
  'import.import_project': 'Importar proyecto',
  'import.importing': 'Importando...',
  'import.parse_error': 'No se pudo parsear el archivo.',
  'import.import_error': 'No se pudo importar el proyecto.',

  'export.title': 'Exportar documento',
  'export.format': 'Formato',
  'export.format_docx': 'DOCX',
  'export.format_pdf_soon': 'PDF (próximamente)',
  'export.status': 'Estado',
  'export.status_draft': 'Draft',
  'export.status_confidential': 'Confidential',
  'export.status_final': 'Final',
  'export.include_metadata': 'Incluir metadatos (autor/versión/fecha/id)',
  'export.watermark': 'Watermark',
  'export.pagination': 'Paginación',
  'export.export': 'Exportar',
  'export.exporting': 'Exportando…',

  'psm.header_edit_title': 'Editar Proyecto',
  'psm.header_create_title': 'Crear Nuevo Proyecto',
  'psm.header_edit_subtitle': 'Actualiza metadatos, clave y mantenimiento',
  'psm.header_create_subtitle': 'Configura los detalles iniciales',
  'psm.header_targets_subtitle': 'Ajusta el objetivo y el rango de palabras',
  'psm.header_targets_hint': 'Abre esta zona para recalibrar el alcance del manuscrito',
  'psm.header_references_subtitle': 'Resumen de la bibliografía del proyecto',
  'psm.header_references_hint': 'Consulta el estado y abre la biblioteca completa cuando la necesites',
  'psm.alert_select_genre': 'Selecciona un género',
  'psm.alert_invalid_genre': 'Género inválido',
  'psm.saved': 'Cambios guardados',
  'psm.basic_info': 'Información básica',
  'psm.genre': 'Género',
  'psm.word_targets': 'Objetivos de palabras',
  'editor.pending_badge_suffix': 'pendientes',
  'editor.pending_badge_title': 'Ver secciones pendientes',
  'editor.pending_badge_aria': '{count} pendientes. Mostrar detalle',
  'editor.pending_tooltip_heading': 'Pendiente de cerrar',
  'editor.pending_tooltip_more': 'mas',
  'editor.pending_status_todo': 'Pendiente',
  'editor.pending_status_draft': 'En borrador',
  'editor.continue_writing': 'Continuar escribiendo',
  'editor.open_and_write': 'Abrir y escribir',
  'editor.next_pending': 'Siguiente',
  'editor.progress_pill_label': 'Ritmo',
  'editor.target_pill_label': 'Objetivo',
  'editor.edit_target_words': 'Editar objetivo de palabras',
  'workspace.insert_figure': 'Insertar figura',
  'workspace.insert_figure_short': 'Figura',
  'workspace.insert_figure_title': 'Insertar figura en el manuscrito',
  'workspace.insert_citation': 'Insertar cita',
  'workspace.insert_references': 'Insertar referencias',
  'workspace.insert_references_short': 'Referencias',
  'workspace.insert_references_title': 'Insertar referencias en el manuscrito',
  'workspace.manage_bibliography': 'Bibliografía',
  'workspace.manage_bibliography_empty': 'Bibliografía del proyecto',
  'workspace.manage_bibliography_with_count': 'Bibliografía del proyecto, {{count}} referencias',
  'workspace.manage_bibliography_with_issues': 'Bibliografía del proyecto, {{count}} referencias incompletas',
  'workspace.manage_figures': 'Gestionar figuras',
  'workspace.manage_figures_short': 'Figuras',
  'workspace.manage_figures_title': 'Gestionar figuras de la sección',
  'workspace.manage_bibliography_title': 'Abrir bibliografía del proyecto',
  'workspace.select_section_first': 'Selecciona una sección para usar esta acción',
  'workspace.reference_targets_figures': 'Figuras',
  'workspace.reference_targets_callouts': 'Recuadros',
  'workspace.reference_targets_chapters': 'Otros capítulos',
  'workspace.reference_bibliography_picker_hint': 'Busca la referencia y añade un localizador si hace falta.',
  'workspace.reference_bibliography_locator_label': 'Localizador',
  'workspace.reference_bibliography_locator_placeholder': 'p. 42',
  'workspace.reference_bibliography_no_results_title': 'No hay referencias para esta búsqueda',
  'workspace.reference_bibliography_no_results_body': 'Limpia la búsqueda o abre la biblioteca para crear o corregir referencias.',
  'workspace.reference_bibliography_clear_search': 'Limpiar búsqueda',
  'workspace.coming_soon': 'Próximamente',
  'workspace.project_tools_subtitle': 'Acciones secundarias y herramientas del proyecto.',
  'editor.typewriter_active': 'Máquina activa',
  'editor.typewriter_anchor_aria': 'Mover la línea de escritura del modo máquina',
  'editor.typewriter_anchor_hint': 'Ajusta la altura de la línea de escritura',
  'psm.encryption_zone': 'Zona de cifrado',
  'psm.references_heading': 'Bibliografía',
  'psm.references_help': 'Gestiona aquí la biblioteca de citas del proyecto. Luego podrás insertar tokens `[@citeKey]` directamente en el manuscrito.',
  'psm.references_summary_help': 'Consulta el estado de la bibliografía del proyecto y abre la biblioteca editorial para crear, revisar y completar referencias.',
  'psm.references_open_library': 'Abrir biblioteca',
  'psm.references_modal_subtitle': 'Biblioteca editorial para preparar y revisar las citas del proyecto.',
  'psm.references_modal_total': 'referencias',
  'psm.references_modal_ready': 'listas para citar',
  'psm.references_modal_list': 'Biblioteca',
  'psm.references_modal_editor': 'Referencia activa',
  'psm.references_modal_empty': 'Todavía no hay referencias en esta biblioteca.',
  'psm.references_modal_missing_key': 'Sin clave de cita',
  'psm.references_explorer_hint': 'Busca, filtra y salta directo a la referencia que necesitas.',
  'psm.references_search_placeholder': 'Buscar por título, clave o autor',
  'psm.references_filter_all': 'Todas',
  'psm.references_filter_book': 'Libros',
  'psm.references_filter_journal_article': 'Artículos',
  'psm.references_filter_webpage': 'Web',
  'psm.references_filter_other': 'Otros',
  'psm.references_filter_incomplete': 'Incompletas',
  'psm.references_empty_title': 'Tu biblioteca todavía está vacía',
  'psm.references_empty_body': 'Empieza creando una referencia y luego podrás editarla con el mismo flujo editorial que usas para citarla.',
  'psm.references_empty_action': 'Añadir referencia',
  'psm.references_no_results_title': 'No hay resultados para esta vista',
  'psm.references_no_results_body': 'Prueba otra búsqueda o limpia los filtros para volver a ver la biblioteca completa.',
  'psm.references_no_results_clear': 'Limpiar filtros',
  'psm.references_editor_hint': 'Edita la referencia seleccionada y guarda cuando quede lista para citar.',
  'psm.references_editor_empty': 'Añade una referencia para empezar a construir la biblioteca bibliográfica del proyecto.',
  'psm.references_editor_empty_filtered': 'No hay ninguna referencia visible con los filtros actuales. Limpia la búsqueda o cambia la clasificación.',
  'psm.references_return_to_picker': 'Volver al selector',
  'psm.references_modal_add_author': 'Añadir autor',
  'psm.references_modal_remove_author': 'Quitar autor',
  'psm.references_add': 'Añadir referencia',
  'psm.references_new': 'Nueva referencia',
  'psm.references_delete': 'Eliminar',
  'psm.references_cite_key': 'Clave de cita',
  'psm.references_type': 'Tipo',
  'psm.references_title': 'Título',
  'psm.references_year': 'Año',
  'psm.references_publisher': 'Editorial / institución',
  'psm.references_journal': 'Revista / publicación',
  'psm.references_pages': 'Páginas',
  'psm.references_url': 'URL',
  'psm.references_authors': 'Autores',
  'psm.references_authors_hint': 'Mantén el orden de firma tal y como quieres que se cite.',
  'psm.references_author_given': 'Nombre',
  'psm.references_author_family': 'Apellido',
  'psm.references_type_book': 'Libro',
  'psm.references_type_journal_article': 'Artículo',
  'psm.references_type_webpage': 'Web',
  'psm.references_type_report': 'Informe',
  'psm.references_type_chapter': 'Capítulo',
  'psm.references_type_thesis': 'Tesis',
  'psm.references_type_other': 'Otro',
  'psm.footer_label': 'Acciones del formulario',
  'psm.footer_unsaved': 'Cambios sin guardar',
  'psm.footer_clean': 'Sin cambios',
  'psm.footer_create_hint': 'Configura y crea tu nuevo proyecto',
  'psm.footer_pending': 'Pendiente de guardar',
  'psm.footer_shortcuts': 'Atajos: {saveShortcut} guardar, {closeShortcut} cerrar',
  'psm.footer_cancel': 'Cancelar',
  'psm.footer_primary_create': 'Crear',
  'psm.footer_primary_close': 'Cerrar',
  'psm.footer_primary_save': 'Guardar',

  'sync.title': 'Sync segura',
  'sync.subtitle': 'Elige qué versión conservar para cada sección con cambios.',
  'sync.close_force': 'Forzar cierre',
  'sync.conflicts_apply_all': '{count} conflicto{suffix}. Aplicar a todos:',
  'sync.apply_local': 'Usar todo local',
  'sync.apply_remote': 'Usar todo remoto',
  'sync.error_enable_sync': 'Activa "Sync con la nube" para ejecutar una sync segura.',
  'sync.error_beta_blocked': 'Acceso progresivo: la sync cloud todavía no está disponible para esta cuenta.',
  'sync.error_timeout': 'La sincronización tardó demasiado. Puedes cerrar y reintentar.',
  'sync.retry': 'Reintentar sync segura',
  'sync.degraded_timeout': 'Sync en modo degradado: el conteo remoto agotó el tiempo de espera. Puedes continuar con revisión manual, reintentar o subir solo cambios locales.',
  'sync.degraded_error': 'Sync en modo degradado: {error}',
  'sync.degraded_generic': 'el backend remoto no respondió de forma estable.',
  'sync.degraded_unverified_title': 'No se pudo verificar el estado remoto',
  'sync.degraded_unverified_desc': 'Cambios locales pendientes en este proyecto: {versions} versiones, {sections} secciones, {contents} contenidos.',
  'sync.degraded_push_confirm': 'Entiendo el riesgo y quiero subir solo mis cambios locales del proyecto activo.',
  'sync.degraded_push_confirm_required': 'Confirma que quieres subir solo cambios locales para continuar.',
  'sync.degraded_push_no_changes': 'No hay cambios locales pendientes para subir en modo degradado.',
  'sync.degraded_push_action': 'Subir solo cambios locales',
  'sync.strict_blocked_unverified': 'Ruta estricta bloqueada: no se puede verificar remoto. Usa "Subir solo cambios locales" o reintenta análisis.',
  'sync.retry_analysis': 'Reintentar análisis',
  'sync.preparing': 'Preparando análisis...',
  'sync.running': 'Sincronizando… (puede tardar hasta 90 segundos)',
  'sync.no_conflicts': 'Sin conflictos detectados. Pulsa "Ejecutar sync segura" para continuar.',
  'sync.no_conflicts_degraded': 'Sin conflictos verificables. El modo estricto está bloqueado mientras remoto no sea verificable.',
  'sync.resolution': 'Resolución',
  'sync.option_keep_local': 'Quedarme con local (móvil)',
  'sync.option_keep_remote': 'Quedarme con remoto (servidor)',
  'sync.option_preserve_both': 'Preservar ambos (crea versión conflicto)',
  'sync.option_abort': 'Abortar sync',
  'sync.warning_overwrite_local': 'Aviso: se sobreescribirán los cambios locales con el contenido del servidor.',
  'sync.no_decision_needed': 'Sin decisión necesaria',
  'sync.run': 'Ejecutar sync segura',
  'sync.choose_resolution': 'Elige una resolución para cada conflicto.',
  'sync.counts_line': 'Local: {lp} proj · {lv} ver · {ls} sec · {lc} txt | Remoto: {rp} · {rv} · {rs} · {rc}',

  'editor.ai_assistant': 'Asistente IA legacy',
  'editor.close_ai_assistant': 'Cerrar asistente IA legacy',
  'editor.zen_structure_badge_title': 'Ver estructura del proyecto',
  'editor.zen_structure_badge_aria': 'Sección activa: {label}. Toca para abrir la estructura del proyecto.',
  'editor.zen_structure_hint_title': 'Aquí está el índice del proyecto',
  'editor.zen_structure_hint_body': 'Toca para abrir la estructura.',
  'lens.action': 'Ideas',
  'lens.action_open': 'Abrir Lens global',
  'global_lens.shell_badge': 'Global Lens',
  'global_lens.shell_title': 'Atlas editorial del proyecto',
  'global_lens.back_to_editor': 'Volver al manuscrito',
  'global_lens.mobile_tab.structure': 'Estructura',
  'global_lens.mobile_tab.tree': 'Árbol',
  'global_lens.mobile_tab.actions': 'Acciones',
  'global_lens.no_project': 'Abre un proyecto para ver su esqueleto global.',
  'global_lens.empty_title': 'Todavía no hay capítulos en este proyecto.',
  'global_lens.empty_body': 'Crea la estructura primero y luego usa Lens global para revisar el hilo completo.',
  'global_lens.health_badge': 'Diagnóstico global',
  'global_lens.health_title': 'Mapa de salud del libro',
  'global_lens.health_progress': 'Progreso editorial',
  'global_lens.health_total_sections': '{count} secciones',
  'global_lens.health_requires_attention': '{count} requieren atención',
  'global_lens.health_no_ideas': '{count} sin ideas',
  'global_lens.health_marked_for_delete': '{count} marcadas para poda',
  'global_lens.health_grouped_or_materialized': '{count} agrupadas o materializadas',
  'global_lens.recommended_label': 'Siguiente jugada',
  'global_lens.focus_next': 'Siguiente foco',
  'global_lens.focus_target': 'Foco {count}',
  'global_lens.structure_badge': 'Estructura',
  'global_lens.structure_title': 'Capítulos y subsecciones',
  'global_lens.structure_attention': 'Atención',
  'global_lens.header_badge': 'Sección enfocada',
  'global_lens.linked_ideas': '{count} ideas vinculadas',
  'global_lens.loose_ideas': '{count} ideas sueltas',
  'global_lens.board_groups': '{count} ideas agrupadas',
  'global_lens.open_board': 'Trabajar en pizarra',
  'global_lens.open_manuscript': 'Ir al manuscrito',
  'global_lens.view_container': 'Ver contenedor',
  'global_lens.mark_delete': 'Marcar para borrar',
  'global_lens.unmark_delete': 'Quitar marca',
  'global_lens.next_section': 'Siguiente sección',
  'global_lens.column_roots': 'Partes',
  'global_lens.column_roots_eyebrow': 'Libro desplegado',
  'global_lens.column_children': 'Subsecciones',
  'global_lens.column_ideas': 'Ideas',
  'global_lens.column_empty': 'Vacío',
  'global_lens.column_empty_eyebrow': 'Sección terminal',
  'global_lens.column_sections': 'Secciones',
  'global_lens.column_subsections': 'Sub-secciones',
  'global_lens.column_children_count': '{count} hijas',
  'global_lens.column_direct_ideas_hint': '{count} ideas directas en espera',
  'global_lens.column_direct_ideas_count': '{count} ideas directas',
  'global_lens.metric.no_ideas': 'Sin ideas',
  'global_lens.metric.loose_ideas': 'Ideas sueltas',
  'global_lens.metric.prune': 'Poda',
  'global_lens.metric.direct_loose_ideas_label': 'Ideas sueltas directas',
  'global_lens.metric.direct_loose_ideas': '{count} ideas sueltas directas',
  'global_lens.metric.context_ideas': 'Ideas del contexto',
  'global_lens.metric.words': 'palabras',
  'global_lens.metric.child_sections': 'Secciones hijas',
  'global_lens.metric.hidden_direct_ideas_label': 'Ideas directas ocultas',
  'global_lens.metric.hidden_direct_ideas': '{count} ideas directas ocultas',
  'global_lens.metric.direct_ideas': 'Ideas directas',
  'global_lens.metric.connected_ideas': 'Ideas conectadas',
  'global_lens.empty_editorial_title': 'Esta sección aún no tiene hilo propio',
  'global_lens.mobile_breadcrumbs': 'Columnas visibles',
  'global_lens.mobile_prev_column': 'Anterior',
  'global_lens.mobile_next_column': 'Siguiente',
  'global_lens.tree_badge': 'Árbol de ideas',
  'global_lens.tree_title': 'Estructura argumental de la sección',
  'global_lens.no_connections': 'Esta sección tiene ideas, pero todavía no forman un árbol conectado. Revísalas en la pizarra y decide el hilo.',
  'global_lens.no_ideas_title': 'Todavía no hay ideas en esta sección',
  'global_lens.no_ideas_body': 'Esta sección aún no tiene ideas propias. Puedes trabajarla en la pizarra y empezar a construir su hilo.',
  'global_lens.no_ideas_with_context': 'Esta sección aún no tiene ideas propias. El contenedor sí tiene material, así que puedes volver a él o trabajar esta sección en la pizarra.',
  'global_lens.loose_badge': 'Ideas sueltas',
  'global_lens.loose_title': 'Ideas sin conexión clara',
  'global_lens.loose_empty': 'No hay ideas sueltas en esta sección.',
  'global_lens.loose_empty_no_ideas': 'Cuando empieces a idear esta sección, las ideas sueltas aparecerán aquí.',
  'global_lens.open_in_board': 'Abrir en pizarra',
  'global_lens.toggle_subsections': 'Sub-secciones',
  'global_lens.toggle_direct_ideas': 'Ideas directas',
  'global_lens.secondary_relations': '+{count} relaciones',
  'global_lens.idea_inserted': 'Insertada',
  'global_lens.idea_pending': 'Pendiente',
  'global_lens.idea_notes_empty': 'Sin notas todavía.',
  'global_lens.scope_only': 'Ámbito: solo esta sección',
  'global_lens.scope_with_descendants': 'Ámbito: esta sección y descendientes',
  'global_lens.context_label': 'Contexto: {label}',
  'global_lens.mobile_focus': 'Árbol de: {label}',
  'global_lens.structure_context': 'Contexto',
  'global_lens.structure_current': 'Actual',
  'global_lens.structure_delete_badge': 'Borrar',
  'global_lens.chapter_status.no_ideas': 'Sin ideas',
  'global_lens.chapter_status.loose_ideas': 'Ideas sueltas',
  'global_lens.chapter_status.grouped_in_board': 'Agrupado en pizarra',
  'global_lens.chapter_status.materialized': 'Materializado',
  'global_lens.chapter_status.marked_for_delete': 'Marcado para borrar',
  'global_lens.action.start_ideation': 'Empezar a idear',
  'global_lens.action.connect_loose_ideas': 'Conectar ideas sueltas',
  'global_lens.action.prune_candidate': 'Podar sección',
  'global_lens.action.expand_section': 'Expandir sección',
  'global_lens.action.continue_draft': 'Seguir borrador',
  'global_lens.reason.no_ideas': 'Esta sección aún no tiene hilo de ideas. Conviene arrancarla en la pizarra antes de escribir a ciegas.',
  'global_lens.reason.loose_ideas': 'Aquí hay ideas sueltas sin hilo resuelto. Primero conéctalas y luego expande el borrador.',
  'global_lens.reason.delete_candidate': 'Esta sección ya está marcada para poda. Decide si se queda o sale.',
  'global_lens.reason.direct_ideas_hidden': 'La sección ya tiene ideas directas, pero la estructura hija esconde el punto de palanca. Ábrela y decide el hilo.',
  'global_lens.reason.materialized': 'Aquí ya hay borrador materializado. Conviene seguir escribiendo antes de abrir más ramas.',
  'global_lens.reason.grouped_in_board': 'Esta sección ya tiene material agrupado en pizarra. Toca expandirlo en progreso real.',
  'lens.panel_tab.analysis': 'Análisis',
  'lens.panel_tab.ideas': 'Ideas',
  'idea_lens.no_project': 'Abre un proyecto para activar Idea Lens.',
  'idea_lens.panel_subtitle': 'Mapa de ideas del proyecto.',
  'idea_lens.surface_badge': 'Idea Lens',
  'idea_lens.title': 'Borrador visual del ensayo',
  'idea_lens.subtitle': 'Apunta ideas y colócalas donde te ayuden a escribir.',
  'idea_lens.workspace_title': 'Borrador visual del ensayo',
  'idea_lens.workspace_title_vnext': 'Pizarra de ideas del ensayo',
  'idea_lens.workspace_hint': 'Apunta una idea, ponla en un capítulo y recupérala al escribir.',
  'idea_lens.workspace_focus_hint': 'La Idea Lens ya está abierta en el lienzo principal.',
  'idea_lens.workspace_empty_hint': 'Abre el mapa grande para crear y ordenar ideas.',
  'idea_lens.mode_board': 'Pizarra',
  'idea_lens.mode_manuscript': 'Manuscrito',
  'idea_lens.board_hint': 'Mueve ideas, conéctalas y luego llévalas al manuscrito.',
  'idea_lens.manuscript_hint': 'Asigna cada idea a una sección y define dónde más ayuda.',
  'idea_lens.new_placeholder': 'Apunta una idea breve',
  'idea_lens.new_placeholder_board': 'Apunta una idea breve',
  'idea_lens.create': 'Crear',
  'idea_lens.autolink_hint': 'Nace en {section}. Luego puedes moverla o añadir apoyos.',
  'idea_lens.spawn_selected_hint': 'La nueva idea aparecerá cerca de la idea activa.',
  'idea_lens.spawn_center_hint': 'La nueva idea aparecerá en el centro de la pizarra.',
  'idea_lens.empty': 'Todavía no hay ideas.',
  'idea_lens.empty_short': 'Crea la primera arriba y sigue el hilo del ensayo.',
  'idea_lens.board_empty_title': 'Todavía no hay ideas sobre la pizarra.',
  'idea_lens.board_empty_hint': 'Crea la primera arriba y empieza a ordenar el hilo del ensayo.',
  'idea_lens.selection_title': 'Selección',
  'idea_lens.selection_count': '{count} ideas seleccionadas',
  'idea_lens.selection_empty': 'Selecciona una o varias ideas para agruparlas.',
  'idea_lens.selection_none': 'Sin selección',
  'idea_lens.selection_single': '1 seleccionada',
  'idea_lens.selection_multiple': '{count} seleccionadas',
  'idea_lens.draft_chapter_title': 'Capítulos borrador',
  'idea_lens.board_group_title': 'Grupo en la pizarra',
  'idea_lens.board_group_no_group': 'Sin grupo',
  'idea_lens.board_group_materialized': 'Convertido en sección',
  'idea_lens.manuscript_chapter_title': 'Sección en el manuscrito',
  'idea_lens.draft_chapter_badge': 'Capítulo borrador',
  'idea_lens.board_group_category': 'Capítulo',
  'idea_lens.board_group_status_draft': 'Solo pizarra',
  'idea_lens.board_group_status_in_manuscript': 'Sección real creada',
  'idea_lens.board_group_status_primary_here': 'Lugar activo',
  'idea_lens.board_group_status_secondary_here': 'Apoyos aquí',
  'idea_lens.board_group_status_draft_short': 'Borr.',
  'idea_lens.board_group_status_in_manuscript_short': 'Real',
  'idea_lens.board_group_status_primary_here_short': 'Aquí',
  'idea_lens.board_group_status_secondary_here_short': 'Apoyo',
  'idea_lens.draft_chapter_inspector': 'Capítulo',
  'idea_lens.draft_chapter_title_label': 'Título del capítulo',
  'idea_lens.draft_chapter_sequence_label': 'Etiqueta de numeración',
  'idea_lens.draft_chapter_status': 'Estado del capítulo',
  'idea_lens.draft_chapter_status_materialized': 'Materializado',
  'idea_lens.draft_chapter_status_unmaterialized': 'Solo en pizarra',
  'idea_lens.draft_chapter_linked_section': 'Sección vinculada',
  'idea_lens.delete_draft_chapter': 'Eliminar capítulo',
  'idea_lens.delete_draft_chapter_confirm': 'Eliminar "{title}" deshará su agrupación en la pizarra. ¿Continuar?',
  'idea_lens.delete_draft_chapter_has_nodes': 'Mueve o elimina las ideas antes de borrar el capítulo.',
  'idea_lens.materialize_cta': 'Crear en estructura',
  'idea_lens.materialize_modal_title': 'Convertir en capítulo real',
  'idea_lens.materialize_title_label': 'Título del capítulo',
  'idea_lens.materialize_title_placeholder': 'Nombre del capítulo…',
  'idea_lens.materialize_preview_label': 'Vista previa',
  'idea_lens.materialize_parent_label': 'Capítulo padre (opcional)',
  'idea_lens.materialize_parent_none': 'Sin padre',
  'idea_lens.materialize_confirm': 'Crear',
  'idea_lens.materialize_cancel': 'Cancelar',
  'idea_lens.coverage_title': 'Cobertura',
  'idea_lens.coverage_mark': 'Marcar como escrita',
  'idea_lens.coverage_unmark': 'Desmarcar',
  'idea_lens.not_linked_hint': 'Esta idea no está asignada a esta sección. Ábrela en el tablón para enlazarla.',
  'idea_lens.filter_active_count': 'ideas vinculadas',
  'idea_lens.hint_board_group': 'Agrupa esta idea en el lienzo. Si el grupo se convirtió en capítulo real, aparece el chip verde.',
  'idea_lens.hint_coverage': '¿Ya escribiste sobre esta idea en la sección activa? Márcala como escrita.',
  'idea_lens.hint_manuscript_chapter': 'La sección exacta del manuscrito donde vive esta idea.',
  'idea_lens.primary_location_help_title': 'Lugar principal',
  'idea_lens.primary_location_help_body': 'El menú cambia al momento dónde vive esta idea. "Usar sección activa" es solo un atajo, y "Quitar lugar principal" la deja sin ubicación principal.',
  'idea_lens.primary_location_current': 'Ahora vive en {location}',
  'idea_lens.primary_location_empty': 'Todavía no tiene lugar principal.',
  'idea_lens.active_section_label': 'Sección activa',
  'idea_lens.active_section_description': 'Es la sección abierta ahora en el manuscrito.',
  'idea_lens.active_section_empty': 'No hay sección activa.',
  'idea_lens.use_active_section_short': 'Usar sección activa',
  'idea_lens.use_active_section_tooltip': 'Atajo para asignar como lugar principal la sección que tienes abierta ahora.',
  'idea_lens.clear_primary_location': 'Quitar lugar principal',
  'idea_lens.clear_primary_location_tooltip': 'Deja esta idea sin lugar principal. Es lo mismo que elegir la opción vacía del menú.',
  'idea_lens.secondary_locations_help_title': 'Apariciones secundarias',
  'idea_lens.secondary_locations_help_body': 'Úsalas para marcar dónde más puede aparecer una idea, sin mover su lugar principal.',
  'idea_lens.coverage_help_title': 'Cobertura',
  'idea_lens.coverage_help_body': 'Marca si ya escribiste esta idea en la sección activa. No cambia dónde vive la idea.',
  'idea_lens.connections_help_title': 'Conexiones',
  'idea_lens.connections_help_body': 'Muestra qué ideas salen de esta y cuáles llegan a ella dentro de la pizarra.',
  'idea_lens.connections_outgoing_title': 'Salen de esta idea',
  'idea_lens.connections_incoming_title': 'Llegan a esta idea',
  'idea_lens.connections_outgoing_empty': 'No hay conexiones salientes.',
  'idea_lens.connections_incoming_empty': 'No hay conexiones entrantes.',
  'idea_lens.no_relations_bidirectional': 'No hay conexiones entrantes ni salientes.',
  'idea_lens.active_section_ideas': 'Ideas para',
  'idea_lens.draft_chapter_placeholder': 'Nombre del capítulo borrador',
  'idea_lens.draft_chapter_select_placeholder': 'Destino',
  'idea_lens.draft_chapter_assigned': 'Ahora vive en {title}.',
  'idea_lens.draft_chapter_empty': 'Todavía no forma parte de ningún capítulo borrador.',
  'idea_lens.create_draft_chapter': 'Crear capítulo',
  'idea_lens.assign_selected': 'Asignar',
  'idea_lens.clear_group': 'Quitar',
  'idea_lens.assign_select_target_hint': 'Elige primero un capítulo borrador para mover ahí la selección.',
  'idea_lens.delete_group': 'Eliminar grupo',
  'idea_lens.multi_assign_hint': 'Agrupa estas {count} ideas en un capítulo borrador local.',
  'idea_lens.multi_select_connections_hint': 'Las conexiones se editan una idea cada vez. Mantén la selección múltiple para agrupar.',
  'idea_lens.cluster_label': 'Capítulo',
  'idea_lens.go_to_section': 'Abrir capítulo',
  'idea_lens.empty_notes': 'Añade una nota breve.',
  'idea_lens.detail_title': 'Idea activa',
  'idea_lens.board_inspector': 'Idea activa',
  'idea_lens.manuscript_inspector': 'Asignación al manuscrito',
  'idea_lens.delete': 'Eliminar',
  'idea_lens.field_title': 'Título',
  'idea_lens.field_type': 'Tipo',
  'idea_lens.field_notes': 'Notas',
  'idea_lens.field_notes_hint': 'Escribe normal',
  'idea_lens.notes_placeholder': 'Apunta el ángulo, ejemplo o transición que quieres recordar.',
  'idea_lens.section_links': 'Lugar principal',
  'idea_lens.link_current': 'Usar aquí',
  'idea_lens.unlink_current': 'Quitar enlace',
  'idea_lens.no_links': 'Esta idea todavía no está enlazada a ninguna sección.',
  'idea_lens.open_picker': 'Elegir sección',
  'idea_lens.close_picker': 'Cerrar selector',
  'idea_lens.link_picker_hint': 'Elige una sección principal y, si hace falta, marca otras secciones o subsecciones donde también te ayuda.',
  'idea_lens.link_picker_title': 'Árbol del manuscrito',
  'idea_lens.link_picker_subtitle': 'Marca dónde también aparece',
  'idea_lens.tree_root': 'Capítulo',
  'idea_lens.tree_child': 'Subsección',
  'idea_lens.tree_active': 'En foco',
  'idea_lens.linked_state': 'Ligada',
  'idea_lens.unlinked_state': 'Libre',
  'idea_lens.linked_summary': '{count} secciones ligadas.',
  'idea_lens.primary_chapter': 'Capítulo principal',
  'idea_lens.primary_section': 'Sección principal',
  'idea_lens.extra_sections': 'Apariciones secundarias',
  'idea_lens.choose_chapter_first': 'Primero elige el capítulo principal.',
  'idea_lens.choose_section_first': 'Primero elige la sección principal.',
  'idea_lens.no_extra_sections': 'Este capítulo no tiene subsecciones para marcar.',
  'idea_lens.no_extra_targets': 'No quedan otras secciones disponibles para marcar.',
  'idea_lens.move_to_current_chapter': 'Mover al capítulo actual',
  'idea_lens.move_to_current_section': 'Mover a la sección actual',
  'idea_lens.use_here': 'Usar aquí',
  'idea_lens.assign_to_manuscript': 'Asignar al manuscrito',
  'idea_lens.board_assignment_empty': 'Todavía no vive en ninguna sección.',
  'idea_lens.placement_with_extras': '{chapter} + {count} apoyos',
  'idea_lens.group_count': '{count} ideas',
  'idea_lens.extra_count': '+{count} extras',
  'idea_lens.unplaced_label': 'Sin sección todavía',
  'idea_lens.relations': 'Relaciones',
  'idea_lens.relation_target_placeholder': 'Relacionar con otro nodo',
  'idea_lens.add_relation': 'Conectar',
  'idea_lens.remove_relation': 'Quitar',
  'idea_lens.no_relations': 'Todavía no hay relaciones salientes para este nodo.',
  'idea_lens.no_relations_short': 'Sin relaciones todavía.',
  'idea_lens.board_connection_title': 'Conexiones',
  'idea_lens.board_connection_hint': 'Únelas para marcar continuidad, apoyo o contraste.',
  'idea_lens.start_connection': 'Conectar idea',
  'idea_lens.cancel_connection': 'Cancelar conexión',
  'idea_lens.connection_pick_target': 'Elige otra idea en la pizarra para conectarla.',
  'idea_lens.connection_use_badge_hint': 'Selecciona una idea y usa el conector del badge para enlazarla.',
  'idea_lens.connect_target_placeholder': 'Conectar con otra idea',
  'idea_lens.connection_count': '{count}',
  'idea_lens.select_hint': 'Selecciona una idea para colocarla y pulir su enfoque.',
  'idea_lens.select_board_hint': 'Selecciona una idea para ampliarla, moverla o conectarla.',
  'idea_lens.select_manuscript_hint': 'Selecciona una idea para asignarla al manuscrito.',
  'idea_lens.open_surface': 'Abrir tablón de ideas',
  'idea_lens.open_surface_tooltip': 'Abrir el tablón de ideas del ensayo',
  'idea_lens.open_workspace': 'Abrir mapa',
  'idea_lens.back_to_editor': 'Volver al manuscrito',
  'idea_lens.back_to_global_lens': 'Volver al Atlas',
  'idea_lens.side_toggle_label': 'Ideas ligadas',
  'idea_lens.side_toggle_tooltip': 'Ver ideas ligadas a esta sección',
  'idea_lens.side_toggle_empty_tooltip': 'Llevar a la pizarra',
  'idea_lens.toast_covered': '¡Idea plasmada en el texto!',
  'idea_lens.no_notes': 'Sin notas todavía.',
  'idea_lens.with_ideas_tooltip': '{count} idea ligada|{count} ideas ligadas',
  'idea_lens.side_badge': 'Idea Lens',
  'idea_lens.side_title': 'Ideas para esta parte',
  'idea_lens.side_empty': 'No hay ideas aquí todavía.',
  'idea_lens.side_empty_cta': 'Crear ideas',
  'idea_lens.side_direct': 'Ligadas a esta sección',
  'idea_lens.side_contextual': 'Ideas del capítulo',
  'idea_lens.side_contextual_hint': 'Mostramos primero las ideas del capítulo para que no pierdas el hilo.',
  'idea_lens.covered': 'Cubierta',
  'idea_lens.open': 'Abierta',
  'idea_lens.mark_covered': 'Marcar cubierta',
  'idea_lens.mark_open': 'Reabrir',
  'idea_lens.arrange_selected': 'Ordenar',
  'idea_lens.arrange_selected_hint': 'Reordena las ideas seleccionadas en cuadrícula',
  'idea_lens.new_placeholder_board_hint': 'Pulsa N para enfocar · Enter para crear',
  'idea_lens.link_count': '{count} enlaces',
  'idea_lens.covered_count': '{count} cubiertas',
  'idea_lens.side_close': 'Cerrar panel de ideas',
  'idea_lens.insert_idea': 'Insertar aquí',
  'idea_lens.develop_here': 'Desarrollar aquí',
  'idea_lens.mention_here': 'Mencionar aquí',
  'idea_lens.status_inserted': 'Insertada',
  'idea_lens.status_pending': 'Pendiente',
  'idea_lens.toast_inserted': '¡Idea insertada en el manuscrito!',
  'idea_lens.level_label': 'Nivel {n}',
  'idea_lens.show_next_level': 'Ver siguiente nivel',
  'idea_lens.all_levels_shown': 'Todos los niveles revelados',
  'idea_lens.collapse_chapter': 'Colapsar capítulo',
  'idea_lens.expand_chapter': 'Expandir capítulo',
  'idea_lens.connect_chapter': 'Conectar con otro capítulo',
  'idea_lens.zoom_in': 'Acercar',
  'idea_lens.zoom_out': 'Alejar',
  'idea_lens.zoom_fit': 'Encajar',
  'idea_lens.sequence_label_placeholder': 'ej. Prólogo, I, A',
  'idea_lens.sequence_label_tooltip': 'Etiqueta breve del capítulo. Haz clic para editarla y usar algo como Prólogo, I o A.',
  'idea_lens.numbering_style_arabic': 'Numeración arábiga',
  'idea_lens.numbering_style_roman': 'Numeración romana',
  'idea_lens.numbering_style_alpha': 'Numeración alfabética',
  'idea_lens.header_block_navigation_eyebrow': 'Navegación',
  'idea_lens.header_block_navigation_title': 'Muévete entre pizarra y manuscrito',
  'idea_lens.header_block_navigation_help_title': 'Cambiar de superficie',
  'idea_lens.header_block_navigation_help_body': 'Desde aquí alternas entre la pizarra y el manuscrito sin perder el contexto de trabajo.',
  'idea_lens.header_block_create_eyebrow': 'Crear ideas',
  'idea_lens.header_block_create_title': 'Captura la idea y decide su numeración',
  'idea_lens.header_block_create_help_title': 'Crear y numerar',
  'idea_lens.header_block_create_help_body': 'La idea nueva aparece cerca de la activa. La numeración afecta a capítulos borrador y a su materialización.',
  'idea_lens.header_numbering_hint': 'La numeración se aplica a capítulos borrador y su paso al manuscrito.',
  'idea_lens.header_block_group_eyebrow': 'Selección',
  'idea_lens.header_block_group_title': 'Selección en pizarra',
  'idea_lens.header_block_group_help_title': 'Asignar o crear capítulo',
  'idea_lens.header_block_group_help_body': 'Asigna la selección a un capítulo borrador existente, crea uno nuevo con esa selección o quítala de su grupo actual.',
  'idea_lens.create_chapter_with_selection': 'Crear capítulo',
  'idea_lens.reveal_next': '{n} más →',
  'idea_lens.draft_chapter_suggested_title': 'Capítulo borrador',
  'idea_lens.primary_location_title': 'Lugar principal',
  'idea_lens.secondary_locations_title': 'Apariciones secundarias',
  'idea_lens.coverage_mark_here': 'Marcar escrita aquí',
  'idea_lens.coverage_unmark_here': 'Reabrir aquí',
  'idea_lens.primary_here_badge': 'Aquí vive',
  'idea_lens.secondary_here_badge': 'También aquí',
  'idea_lens.primary_location_inline': 'Vive en {location}',
  'idea_lens.secondary_count_inline': '+{count} apariciones',
  'idea_lens.secondary_none_inline': 'Sin apariciones secundarias',
  'idea_lens.overlay_primary_here': 'Ideas cuyo lugar principal es aquí',
  'idea_lens.overlay_secondary_here': 'Ideas que también aparecen aquí',
  'idea_lens.overlay_contextual': 'Ideas del capítulo',
  'idea_lens.onboarding_badge': 'Empieza aquí',
  'idea_lens.onboarding_step_1': '1. Crea una idea',
  'idea_lens.onboarding_step_2': '2. Enlázala a una sección',
  'idea_lens.onboarding_step_3': '3. Márcala como cubierta',
  'idea_lens.onboarding_step_board_1': '1. Crea una idea',
  'idea_lens.onboarding_step_board_2': '2. Muévela o conéctala',
  'idea_lens.onboarding_step_board_3': '3. Llévala al manuscrito',
  'idea_lens.dismiss_onboarding': 'Ocultar ayuda',
  'idea_lens.missing_target': 'Nodo no encontrado',
  'idea_lens.node_type.idea': 'Idea',
  'idea_lens.node_type.question': 'Pregunta',
  'idea_lens.node_type.example': 'Ejemplo',
  'idea_lens.node_type.bridge': 'Puente',
  'idea_lens.edge_type.supports': 'Sostiene',
  'idea_lens.edge_type.leads_to': 'Conduce a',
  'idea_lens.edge_type.contrasts': 'Contrasta con',
  'lens.close': 'Cerrar Lenses',
  'lens.panel_title': 'Lens Panel',
  'lens.panel_subtitle': 'Análisis editorial local sobre el manuscrito activo.',
  'lens.run': 'Ejecutar análisis',
  'lens.run_busy': 'Analizando…',
  'lens.run_error': 'No se pudo ejecutar el análisis Lens.',
  'lens.anchor_not_found': 'No se pudo localizar el fragmento actual de esta observación.',
  'lens.no_run': 'Aún no hay análisis para esta combinación de lens y alcance.',
  'lens.no_run_hint': 'Selecciona otra combinación o ejecuta el análisis.',
  'lens.active_run': 'Run activo',
  'lens.no_findings': 'No hay hallazgos prioritarios en este análisis.',
  'lens.all_resolved': 'Todos los hallazgos de este run están marcados como resueltos.',
  'lens.recent_runs': 'Runs recientes',
  'lens.no_recent_runs': 'Todavía no hay historial local de Lens.',
  'lens.show_more': 'Ver más',
  'lens.show_less': 'Ver menos',
  'lens.results_count': '{count} hallazgos',
  'lens.open_count': '{count} abiertos',
  'lens.resolved_count': '{count} resueltos',
  'lens.resolve': 'Resuelto',
  'lens.reopen': 'Reabrir',
  'lens.resolved_group': 'Resueltos',
  'lens.resolved_badge': 'Resuelto',
  'lens.before_excerpt': 'Antes',
  'lens.after_excerpt': 'Ahora',
  'lens.jump_to_fragment': 'Ir al fragmento',
  'lens.scope_target': 'Objetivo',
  'lens.outdated_badge': 'Desactualizado',
  'lens.outdated_hint': 'El texto o la configuración cambiaron desde este análisis. Conviene reanalizar.',
  'lens.rerun': 'Reanalizar',
  'lens.publication_context': 'KDP preflight',
  'lens.publication_action.focus_setting': 'Abrir ajuste',
  'lens.publication_action.focus_preflight': 'Ver preflight',
  'lens.publication_action.preview_pages': 'Ver páginas afectadas',
  'lens.publication_action.manual_review': 'Revisión manual',
  'lens.publication_action.open_section': 'Abrir sección',
  'lens.publication_pages': '{count} página(s): {pages}',
  'lens.section_fallback': 'Sección',
  'lens.scope.section': 'Sección',
  'lens.scope.chapter': 'Capítulo',
  'lens.scope.project': 'Proyecto',
  'lens.name.clarity': 'Clarity',
  'lens.name.structure': 'Structure',
  'lens.name.logic': 'Logic',
  'lens.name.narrative': 'Narrative',
  'lens.name.audience': 'Audience',
  'lens.name.translation': 'Translation',
  'lens.name.publication': 'Publication',
  'lens.severity.low': 'Bajo',
  'lens.severity.medium': 'Medio',
  'lens.severity.high': 'Alto',

  'settings.close_project': 'Cerrar proyecto',
  'settings.edit_project': 'Editar proyecto',
  'settings.ai_assistant': 'Asistente IA',
  'settings.legacy_ai': 'Asistente IA legacy',
  'settings.legacy_ai_description': 'Superficie transicional de chat. No es la via principal de trabajo.',
  'settings.prepare_export': 'Prepare & Export',
  'settings.prepare_export_description': 'Substack-ready Markdown/HTML y handoff manual de clave',

  'prepare_export.title': 'Prepare & Export',
  'prepare_export.subtitle': 'Prepara una versión local para publicar sin depender todavía del sync cloud.',
  'prepare_export.tab_prepare': 'Prepare',
  'prepare_export.tab_export': 'Export',
  'prepare_export.tab_key': 'Key Handoff',
  'prepare_export.no_project': 'Abre un proyecto para preparar y exportar.',
  'prepare_export.prepare_heading': 'Preparación local',
  'prepare_export.prepare_help': 'Elige la versión, ajusta título/subtítulo y define la byline manual antes de exportar.',
  'prepare_export.version_label': 'Versión',
  'prepare_export.version_final': 'final',
  'prepare_export.no_versions': 'No hay versiones disponibles',
  'prepare_export.title_label': 'Título',
  'prepare_export.subtitle_label': 'Subtítulo',
  'prepare_export.contributors_label': 'Contributors / byline',
  'prepare_export.add_contributor': 'Añadir contributor',
  'prepare_export.remove_contributor': 'Quitar',
  'prepare_export.contributor_placeholder': 'Contributor {index}',
  'prepare_export.include_byline': 'Incluir byline en la salida',
  'prepare_export.preview_heading': 'Vista rápida',
  'prepare_export.preview_version': 'Versión: {version}',
  'prepare_export.preview_sections': 'Secciones: {count}',
  'prepare_export.preview_words': 'Palabras: {count}',
  'prepare_export.untitled': 'Sin título',
  'prepare_export.go_to_export': 'Ir a Export',
  'prepare_export.export_heading': 'Salida Substack-ready',
  'prepare_export.export_help': 'Copia o descarga Markdown/HTML determinista generado desde el árbol real del proyecto.',
  'prepare_export.copy_markdown': 'Copiar Markdown',
  'prepare_export.copy_html': 'Copiar HTML',
  'prepare_export.download_markdown': 'Descargar .md',
  'prepare_export.download_html': 'Descargar .html',
  'prepare_export.format_kdp_pdf': 'KDP PDF',
  'prepare_export.premium_lock_publication': 'La exportación publication está disponible en Premium.',
  'prepare_export.premium_lock_publication_hint': 'El preview, el preflight y la salida KDP quedan visibles en Premium sin activar billing todavía.',
  'prepare_export.rich_formatting': 'Formato enriquecido (negrita, cursiva, citas y listas)',
  'prepare_export.print_pagination': 'Paginación para imprimir',
  'prepare_export.syntax_help': 'Sintaxis soportada: `**negrita**`, `*cursiva*`, `> cita`, `- lista`, `1. lista numerada`.',
  'prepare_export.preview_markdown': 'Preview Markdown',
  'prepare_export.preview_html': 'Preview HTML',
  'prepare_export.preview_scale_fit_width': 'Encajar ancho',
  'prepare_export.preview_scale_fit_page': 'Encajar página',
  'prepare_export.preview_scale_100': '100%',
  'prepare_export.html_source': 'Código HTML',
  'prepare_export.kdp_heading': 'KDP Interior PDF v1',
  'prepare_export.kdp_help': 'Maqueta un interior paperback 6x9 cream/no-bleed con páginas explícitas. Chromium es el target recomendado; Safari queda permitido como export best-effort.',
  'prepare_export.kdp_help_cta': 'Ayuda',
  'prepare_export.kdp_help_inline': 'Lo esencial: elige preset, revisa tipografía, ajusta páginas especiales y confirma el preflight antes de imprimir. Insertar figura y cita escribe el token automaticamente; markdown-lite soporta tambien figuras asset://, referencias a figura, citas, ecuaciones, listas alfabeticas y epigrafes. Para el cuerpo del libro no metas lineas en blanco decorativas: deja que KDP controle la respiracion vertical.',
  'prepare_export.kdp_preview_panel': 'Preview KDP',
  'prepare_export.kdp_preview_panel_help': 'Abre primero el preview y deja el resto plegado hasta que necesites tocar algo. La escala del preview se guarda solo en este dispositivo.',
  'prepare_export.kdp_section_profile': 'Perfil y composición',
  'prepare_export.kdp_section_profile_help': 'Preset, reglas de composición, numeración, warnings y ajuste del fondo. Este bloque forma parte de la configuración KDP del proyecto.',
  'prepare_export.kdp_section_typography': 'Tipografía y densidad',
  'prepare_export.kdp_section_metadata': 'Portadilla y metadatos',
  'prepare_export.kdp_help_modal_title': 'Guía rápida KDP y markdown-lite',
  'prepare_export.kdp_help_modal_subtitle': 'Dónde tocar primero y cómo insertar bloques especiales sin salir del flujo del libro.',
  'prepare_export.kdp_help_block_important_title': 'Qué es importante',
  'prepare_export.kdp_help_block_important_body': '1. Elige un preset y una pareja tipográfica.\n2. Revisa portadilla y páginas especiales.\n3. Mira el preflight y el gutter/cosido.\n4. Exporta en Chromium si quieres la salida más fiable.',
  'prepare_export.kdp_help_block_markdown_title': 'Markdown básico',
  'prepare_export.kdp_help_block_markdown_body': '**negrita**\n*cursiva*\n> cita\n- lista\n1. lista numerada',
  'prepare_export.kdp_help_block_advanced_title': 'Bloques KDP',
  'prepare_export.kdp_help_block_advanced_body': 'Figura: ![Caption](asset://<assetId>)\nReferencia a figura: [@fig:riesgo-dashboard]\nCita: [@smith2024]\nCita con localizador: [@smith2024, p. 42]\n\nEcuaciones:\n$$\n\\\\frac{a}{b}\n$$\n$$\n\\\\sqrt{x}\n$$\nInline: x^2 y x_i\n\na. lista alfabetica\nb. segundo elemento\n\n:::epigraph\nTodo esta aun por escribir.\n-- Autor\n:::\n\n:::recuadro\ntitle: Contexto\nvariant: nota\n\nTexto del recuadro.\n:::',
  'prepare_export.kdp_help_block_parts_title': 'Partes y capítulos',
  'prepare_export.kdp_help_block_parts_body': 'Si una sección raíz tiene hijos y su título empieza por "Parte" o "Part", KDP la tratará como apertura de parte. Esa raíz obtiene su propia página y sus hijos directos pasan a maquetarse como capítulos de esa parte.',
  'prepare_export.kdp_help_block_sync_title': 'Qué se guarda y dónde',
  'prepare_export.kdp_help_block_sync_body': 'La estructura, el texto y la configuración KDP canónica del proyecto ya viajan con el propio proyecto. En este dispositivo, el modal además recuerda el tab activo, el panel KDP abierto y el estado local del export al reabrir. La escala del preview y el aviso inicial de ayuda siguen guardándose solo aquí.',
  'prepare_export.kdp_help_modal_done': 'Entendido',
  'prepare_export.kdp_profile_label': 'Preset',
  'prepare_export.kdp_profile_value': 'Paperback 6x9 · tinta negra · papel crema · sin sangrado',
  'prepare_export.kdp_profile_value_label': 'Preset activo',
  'prepare_export.kdp_preset_save': 'Guardar preset',
  'prepare_export.kdp_preset_overwrite': 'Sobrescribir',
  'prepare_export.kdp_preset_delete': 'Eliminar preset',
  'prepare_export.kdp_preset_save_prompt': 'Nombre del nuevo preset KDP',
  'prepare_export.kdp_preset_overwrite_prompt': 'Nombre para sobrescribir el preset KDP',
  'prepare_export.kdp_preset_saved': 'Preset KDP guardado.',
  'prepare_export.kdp_preset_overwritten': 'Preset KDP actualizado.',
  'prepare_export.kdp_preset_deleted': 'Preset KDP eliminado.',
  'prepare_export.kdp_front_matter': 'Incluir portadilla + copyright',
  'prepare_export.kdp_include_toc': 'Incluir tabla de contenidos',
  'prepare_export.kdp_toc_depth': 'Profundidad TOC',
  'prepare_export.kdp_toc_depth_0': 'Solo capitulos',
  'prepare_export.kdp_toc_depth_1': 'Capitulos + subsecciones',
  'prepare_export.kdp_toc_depth_2': 'Hasta dos niveles',
  'prepare_export.kdp_right_page': 'Empezar capítulos en página impar/derecha',
  'prepare_export.kdp_page_numbers': 'Numeración de página',
  'prepare_export.kdp_page_numbers_position': 'Posición de numeración',
  'prepare_export.kdp_page_numbers_center': 'Pie centrado',
  'prepare_export.kdp_page_numbers_right': 'Pie exterior',
  'prepare_export.kdp_running_heads': 'Running heads de libro',
  'prepare_export.kdp_scene_break': 'Separador de escena',
  'prepare_export.kdp_scene_break_asterism': 'Asterismo',
  'prepare_export.kdp_scene_break_blank': 'Espacio en blanco',
  'prepare_export.kdp_typography_heading': 'Tipografía y layout',
  'prepare_export.kdp_typography_help': 'Preset cerrado para pulir caja tipografica, ritmo vertical y respiracion del interior sin abrir maquetacion libre.',
  'prepare_export.kdp_font_pair': 'Pareja tipográfica',
  'prepare_export.kdp_title_alignment': 'Alineación de portadilla',
  'prepare_export.kdp_title_alignment_centered': 'Centrada',
  'prepare_export.kdp_title_alignment_left': 'Alineada a la izquierda',
  'prepare_export.kdp_title_page_heading': 'Ajustes de preview de portadilla',
  'prepare_export.kdp_title_page_help': 'Ajusta titulo, subtitulo y byline visibles en la portadilla interior del PDF KDP.',
  'prepare_export.kdp_layout_density': 'Densidad',
  'prepare_export.kdp_layout_compact': 'Compacto',
  'prepare_export.kdp_layout_standard': 'Estandar',
  'prepare_export.kdp_layout_airy': 'Aireado',
  'prepare_export.kdp_bottom_fit_mode': 'Composición del fondo',
  'prepare_export.kdp_bottom_fit_balanced': 'Equilibrado',
  'prepare_export.kdp_bottom_fit_balanced_plus': 'Equilibrado plus',
  'prepare_export.kdp_subheading_keep_with_next': 'Subtítulo con arranque',
  'prepare_export.kdp_subheading_keep_with_next_off': 'Desactivado',
  'prepare_export.kdp_subheading_keep_with_next_keep_with_2_lines': 'Mantener con 2 líneas',
  'prepare_export.kdp_allow_warnings': 'Permitir exportar con warnings',
  'prepare_export.kdp_preflight': 'Preflight KDP',
  'prepare_export.kdp_page_count': 'Páginas reales: {count}',
  'prepare_export.kdp_gutter': 'Margen interior (gutter/cosido): {value}"',
  'prepare_export.kdp_export_pdf': 'Imprimir / Guardar PDF',
  'prepare_export.kdp_download_report': 'Descargar preflight .json',
  'prepare_export.kdp_download_html': 'Descargar HTML KDP',
  'prepare_export.kdp_print_hint': 'El PDF final soportado oficialmente se genera en Chromium/Chrome. Usa "Guardar como PDF", tamaño real y desactiva headers/footers del navegador.',
  'prepare_export.kdp_print_hint_safari': 'Safari queda permitido como export best-effort. Si el PDF final sale mal, descarga el HTML KDP y ábrelo en Chromium/Chrome para usar "Guardar como PDF", tamaño real y sin headers/footers del navegador.',
  'prepare_export.kdp_issue_error': 'Error',
  'prepare_export.kdp_issue_warning': 'Aviso',
  'prepare_export.kdp_issue_pass': 'OK',
  'prepare_export.kdp_manual_checks': 'Comprobaciones manuales antes de subir a KDP',
  'prepare_export.kdp_engine_checks': 'Validaciones automáticas del layout engine',
  'prepare_export.kdp_preview': 'Preview KDP',
  'prepare_export.kdp_report_downloaded': 'Preflight KDP descargado.',
  'prepare_export.kdp_html_downloaded': 'HTML KDP descargado.',
  'prepare_export.kdp_print_opened': 'Se ha abierto la ventana de impresión KDP.',
  'prepare_export.kdp_print_blocked': 'El navegador ha bloqueado la ventana de impresión. Permite pop-ups e inténtalo de nuevo.',
  'prepare_export.kdp_error_preview': 'No se pudo generar la preview KDP.',
  'prepare_export.kdp_special_pages': 'Páginas especiales',
  'prepare_export.kdp_special_pages_help': 'Gestiona páginas editoriales persistentes del interior KDP: front matter, inserciones entre capítulos raíz y back matter.',
  'prepare_export.kdp_parts_callout_title': 'Cómo funcionan las Partes en beta',
  'prepare_export.kdp_parts_callout_body': 'No existe una entidad aparte para Partes todavía. Si una sección raíz tiene hijos y su título empieza por "Parte" o "Part", el export KDP la maquetará como opener de parte en página propia y tratará a sus hijos directos como capítulos.',
  'prepare_export.kdp_add_special_page': 'Añadir página',
  'prepare_export.kdp_template_acknowledgements': 'Plantilla agradecimientos',
  'prepare_export.kdp_template_copyright': 'Plantilla copyright + ISBN',
  'prepare_export.kdp_template_blank': 'Página en blanco',
  'prepare_export.kdp_template_about_author': 'Plantilla sobre el autor',
  'prepare_export.kdp_template_bibliography': 'Plantilla bibliografía',
  'prepare_export.kdp_template_notes': 'Plantilla notas',
  'prepare_export.kdp_page_disabled': 'Desactivada',
  'prepare_export.kdp_move_up': 'Subir',
  'prepare_export.kdp_move_down': 'Bajar',
  'prepare_export.kdp_delete_page': 'Eliminar',
  'prepare_export.kdp_page_kind': 'Tipo de página',
  'prepare_export.kdp_page_placement': 'Ubicación',
  'prepare_export.kdp_page_anchor': 'Capítulo raíz ancla',
  'prepare_export.kdp_page_anchor_empty': 'Sin capítulo disponible',
  'prepare_export.kdp_page_title': 'Título visible',
  'prepare_export.kdp_page_body': 'Contenido (markdown-lite)',
  'prepare_export.kdp_page_enabled': 'Incluir en el interior',
  'prepare_export.kdp_page_right_start': 'Forzar inicio en página derecha',
  'prepare_export.kdp_focus_pages': 'Páginas afectadas en preview: {pages}',
  'prepare_export.kdp_focus_assets': 'Assets a revisar: {assets}',
  'prepare_export.kdp_open_section': 'Abrir sección',
  'prepare_export.loading_preview': 'Generando preview…',
  'prepare_export.copied_markdown': 'Markdown copiado.',
  'prepare_export.copied_html': 'HTML copiado.',
  'prepare_export.copy_failed': 'No se pudo copiar al portapapeles.',
  'prepare_export.downloaded_markdown': 'Archivo Markdown descargado.',
  'prepare_export.downloaded_html': 'Archivo HTML descargado.',
  'prepare_export.key_heading': 'Handoff manual de clave',
  'prepare_export.key_help': 'Mientras el sync multi-dispositivo siga abierto, la clave se comparte de forma manual.',
  'prepare_export.key_fingerprint': 'Huella',
  'prepare_export.key_missing': 'Sin clave local',
  'prepare_export.key_placeholder': 'Genera o importa una clave en Gray Matter Zone para poder compartirla manualmente.',
  'prepare_export.show_key': 'Mostrar',
  'prepare_export.hide_key': 'Ocultar',
  'prepare_export.copy_key': 'Copiar clave',
  'prepare_export.download_key': 'Descargar clave',
  'prepare_export.import_key': 'Importar/Reemplazar',
  'prepare_export.key_handoff_heading': 'Flujo recomendado',
  'prepare_export.key_handoff_body': 'Este tramo evita colaboración cloud incompleta. Comparte salida y clave fuera de la app hasta cerrar SWK/sync.',
  'prepare_export.key_step_one': 'Exporta Markdown o HTML desde esta pantalla para revisión o publicación.',
  'prepare_export.key_step_two': 'Comparte la clave del proyecto por un canal seguro solo si otra persona necesita descifrar el contenido local.',
  'prepare_export.key_step_three': 'Cuando el otro dispositivo tenga la clave, podrá importar/reemplazarla manualmente y trabajar en local.',
  'prepare_export.error_versions': 'No se pudieron cargar las versiones del proyecto.',
  'prepare_export.error_preview': 'No se pudo generar la preview de exportación.',
} as const
